<template>
    <div class="form form__phone">
        <label
            v-if="label"
            :for="name | toKebabCase"
            class="form__phone_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></label>
        <input
            type="tel"
            class="form__phone_input"
            :placeholder="placeholder"
            :disabled="disabled"
            :id="name | toKebabCase"
            :name="name | toKebabCase"
            :data-vv-as="dataVvAs ? dataVvAs : label.toLowerCase()"
            v-validate="vValidate"
            v-model="newValue"
            @focus="emitFocus"
            @blur="emitBlur"
        >
        <span
            class="form__error form__phone_error"
            v-if="errors.first(toKebabCase(name))"
        >{{ vValidateCustomError || errors.first(toKebabCase(name)) }}</span>
        <template v-if="$slots.default">
            <div class="form__phone_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import { toKebabCase } from '@/functions'

export default {
  name: 'form-phone',
  props: {
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidateCustomError: {
      type: String
    },
    vValidate: {
      type: [Object, String],
      default: () => {
        return { regex: /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?(\d{4}|\d{3}))?$/ }
      }
    }
  },
  computed: {
    newValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.pause()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formphone";
</style>
